module.exports = __webpack_public_path__ + "media/iconic/external-link-b87722c6.svg";